import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DeleteTripRequest, CreateTripRequest, CreateTripResponse, GetTripResponse } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class TripApiService {
  readonly #httpClient = inject(HttpClient);

  public createTrip(request: CreateTripRequest): Observable<CreateTripResponse> {
    return this.#httpClient.post<CreateTripResponse>(`trip/create`, request);
  }

  public getTrip(id: string): Observable<GetTripResponse> {
    return this.#httpClient.get<GetTripResponse>(`trip?tripId=${id}`);
  }

  public deleteTrip(request: DeleteTripRequest): Observable<void> {
    return this.#httpClient.post<void>(`trip/delete`, request);
  }

  public contactOperator(itineraryId: string, tripId: string): Observable<void> {
    return this.#httpClient.post<void>(`trip/contact-operator`, { itineraryId, tripId });
  }
}
